import HubImg from "../../../../../assets/images/HubImg.png";

const HubElements = ({ item, Boxi, handleClick }: any) => {
  return (
    <div
      key={item.id}
      onClick={() => handleClick(item)}
      className={`border p-4  rounded-2xl transition duration-500 cursor-pointer  ${
        Boxi?.id === item.id ? "border-2 border-tomato" : ""
      }`}
    >
      <div className="flex-start-center gap-2">
        <img width={55} src={HubImg} alt={item?.name} />
        <div>
          <p className="text-base text-black">{item?.name}</p>
          <p className="text-sm text-darkBorder mt-1">ساعت کاری : 11 تا 18</p>
        </div>
      </div>
      <p className="text-darkBorder text-xs mt-2">{item?.addressLine}</p>
    </div>
  );
};

export default HubElements;
